import API from "@/lib/API";

export const bookEntryService = {
  createOrUpdateBookEntry: async (data) => {
    try {
      const response = await API.post('/book-entries', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getBookEntryByEstimation: async (estimationId) => {
    try {
      const response = await API.get(`/book-entries/${estimationId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAllBookEntries: async () => {
    try {
      const response = await API.get('/book-entries');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
